import { Box, Popover } from "@mui/material";
import { useState } from "react";
import { Button, ButtonVariant } from "../../core-ui/components/Button/Button";
import { RequestDemoForm } from "../RequestDemoForm";

export const RequestDemoDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Button
        aria-describedby="request-demo-popover"
        variant={ButtonVariant.UNSTYLED}
        onClick={handleClick}
        sx={{ whiteSpace: "nowrap" }}
      >
        Request a Demo
      </Button>
      <Popover
        id="request-demo-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
      >
        <Box sx={{ width: "480px", maxHeight: "80vh", minHeight: "240px" }}>
          <RequestDemoForm />
        </Box>
      </Popover>
    </div>
  );
};
